import DisplayCupBrowse from "../../track-components/DisplayCupBrowse";
import { useState, useEffect } from "react";
import { Link, useLoaderData, useOutletContext } from "react-router-dom";
import "../../../App.css";
import "./Browse.css";

export default function Browse() {

    const [cups, setCups] = useState([]);
    const [width] = useOutletContext();
    const data = useLoaderData();

    useEffect(() => {
        setCups(data);
    }, [data]);

    return <div id="main-container" className="browse">
        <h1>Browse Cups</h1>
        <ol id="cup-list">
            {
                cups.length > 0 &&
                cups.map((element, index) => {
                    return <li key={index} tabIndex="-1" className="trackContainer">
                        <Link to={`/browse/cup/${element.id}`} reloadDocument>
                            <h5 tabIndex={-1}>{element.cupName}</h5>
                            <DisplayCupBrowse
                                key={index}
                                yourCup={false}
                                editName={false}
                                tracks={element.tracks}
                                page="browse"
                                width={width}
                                showCursor={true}
                            />
                        </Link>
                    </li>
                })
            }
        </ol>
    </div>
}